import { render, staticRenderFns } from "./ContractsListFilters.vue?vue&type=template&id=8838b654"
import script from "./ContractsListFilters.vue?vue&type=script&lang=js"
export * from "./ContractsListFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports